export const SERVICE_FEE_ADDRESS = 'SERVICE_FEE_ADDRESS'
export const SERVICE_FEE_PERCENT = 'SERVICE_FEE_PERCENT'
export const LOCALE = 'LOCALE'